<template>
  <el-dialog
    :title="$t('menu.protocol')"
    :visible.sync="dialogVisible"
    width="700px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="from-body">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="auto"
        :rules="rules"
        class="demo-ruleForm"
      >
        <el-form-item :label="$t('pages.equipment.text336')">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t("button.cancel") }}</el-button>
      <el-button type="primary" @click="submit">{{$t("button.determine")}}</el-button>
    </span>
  </el-dialog>
</template>


<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      ruleForm: {
        protocolId: null, //协议ID
        name: "",         //协议名称
      },
      rules: {
        name: {
          required: true,
          message: this.$t("pages.equipment.text337"),
          trigger: "change",
        }
      },
    };
  },
  // 监听弹窗类型
  watch: {
    dialogVisible(newValue) {
      if (newValue) {
        if (this.protocolInfo!=null||this.protocolInfo.protocolId!=null) {
          this.ruleForm.protocolId = this.protocolInfo.id;
          this.ruleForm.name = this.protocolInfo.name;
        }
      }
    },
  },
  computed: {
    ...mapState(["platformData"]),
  },
  mounted() {},
  props: ["dialogVisible", "protocolInfo"],
  methods: {
    //关闭弹窗
    handleClose() {
      this.ruleForm = {
        protocolId: null,
        name: ""
      };
      this.$refs["ruleForm"].resetFields();
      this.$emit("dialogClose");
    },
    //提交
    submit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.request
            .protocolEdit(this.ruleForm)
            .then(() => {
              this.$message.success(this.$t("public.text9"));
              this.$emit("protocolList");
              this.handleClose();
            })
            .catch(() => {});
        }
      });
    },
  },
};
</script>

<style scoped>
.from-body {
  padding: 0 40px;
  box-sizing: border-box;
  width: 80%;
}
.firmware-content {
  display: flex;
}
.firmware-content a {
  margin-right: 20px;
}
</style>